import { useDispatch } from "react-redux";
import { changePageTitle } from "../../../store/slices/layout/layout.slice";

import styles from './NotFound.module.scss';
import { Text } from "../../../common/components";

export function NotFound (){
  
    const dispatch = useDispatch();

    dispatch(changePageTitle('Error 404'));

    return (
        <div className={styles['Error404']}>
            <div className={styles['Error404-content']}>

                <h2>
                    <Text fontStyle='title-large' value='Error 404'></Text>
                </h2>

                <p>
                    <Text fontStyle='body-large' value='Page not found'></Text>
                </p>

            </div>     
        </div>       
    );
}